import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { ObjectPaymentReportRow } from '@econtractor/types';
import { UserNameItem } from 'modules/user';
import { getObjectCardPath } from 'utils/helpers/objects/objectCardPath';
import { usePaymentReport } from '../context/ReportObjectPaymentsProvider';
import { objectPaymentName, paymentDate, paymentMoney, paymentUserName } from '../model/reportObjectPayments';

const ReportObjectPaymentsTableRow = ({ row }: { row: ObjectPaymentReportRow }) => {
    const { t } = useTranslation(['Reports']);
    const report = usePaymentReport();
    const [date, time] = paymentDate(row.dt).split(' ');
    return (
        <tr>
            {report.objectId === undefined && <td className="name">
                {Number(row.objectDeleted) ? <h6 className="mb-1 text-break">{objectPaymentName(row)}</h6> : (
                    <Link className="text-body text-decoration-none" to={getObjectCardPath(row.objectId, Number(row.onlySale) === 1, Number(row.onlyService) === 1)}>
                        <h6 className="mb-1 text-break">{objectPaymentName(row)}</h6>
                    </Link>
                )}
                <p className="text-muted f-12 mb-0">{row.clientName}</p>
                {!!Number(row.objectDeleted) && <span className="badge bg-light-danger text-danger">{t('objectPayments.deletedObject')}</span>}
            </td>}
            <td className="username text-break">
                <UserNameItem smallMode user={{ ID: row.ownerId, userName: paymentUserName(row.ownerName, row.ownerId), userPicture: row.ownerPicture || undefined }} />
            </td>
            <td className="username text-break">
                <UserNameItem smallMode user={{ ID: row.authorId, userName: paymentUserName(row.authorName, row.authorId), userPicture: row.authorPicture || undefined }} />
            </td>
            <td className="date">
                <div>{date}</div>
                <div className="text-muted f-12">{time}</div>
            </td>
            <td className={`amount text-end ${Number(row.payment) < 0 ? 'text-danger' : ''}`}>{paymentMoney(Number(row.payment), !!Number(row.paymentUsd))}</td>
            <td className="file">
                <Button variant="link" className="p-0 text-start text-break" disabled={report.documentLoading} onClick={() => void report.openDocument(row)}>
                    {row.documentName || `#${row.generationId}`}
                </Button>
                {!!Number(row.documentDeleted) && <div><span className="badge bg-light-danger text-danger">{t('objectPayments.deletedDocument')}</span></div>}
            </td>
        </tr>
    );
};

export default ReportObjectPaymentsTableRow;
